import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-glyphicons',
	templateUrl:'./GlyphiconsPluginCompPage.html',
	styles: [],
	styleUrls:['./GlyphiconsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class GlyphiconsPluginCompPage
{
	mdContent_981 = `\`\`\`java
import com.jwebmp.plugins.glyphicons.Glyphicons;
\`\`\``;
	mdContent_982 = `\`\`\`java
// Glyphicons.home.toString() returns "glyphicon glyphicon-home"
\`\`\``;
}
